import { render, staticRenderFns } from "./JudgingPoint.vue?vue&type=template&id=752592cb&scoped=true"
import script from "./JudgingPoint.vue?vue&type=script&lang=js"
export * from "./JudgingPoint.vue?vue&type=script&lang=js"
import style0 from "./JudgingPoint.vue?vue&type=style&index=0&id=752592cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752592cb",
  null
  
)

export default component.exports